/* OWFit - popup de tallas; soporta secciones renderizadas dinámicamente. */
document.addEventListener('click', function (event) {
  const open = event.target.closest('[data-owfit-open]');
  if (open) {
    const dialog = open.closest('[data-owfit-size-guide]')?.querySelector('dialog');
    if (dialog && !dialog.open) dialog.showModal();
    return;
  }
  const close = event.target.closest('[data-owfit-close]');
  if (close) close.closest('dialog')?.close();
});
document.addEventListener('click', function (event) {
  const dialog = event.target.closest('.owfit-size-dialog');
  if (dialog && event.target === dialog) dialog.close();
});
